<template>
  <el-row>
    <b>{{ row.name }}</b>
    <br />
    <span class="right-pad">
      规格：<span>{{ row.standard }}</span>
    </span>
    <span class="right-pad">
      剂型：<span>{{ row.form | dictText("DrugForm") }}</span>
    </span>
    <span class="right-pad">
      数量：<span class="danger">{{ row.quantity }}</span> <span>{{ row.unit }}</span>
    </span>
    <span class="right-pad">
      用法：<span class="danger">{{ row.usage | dictText("DrugUsage") }}</span>
    </span>
    <span class="right-pad">
      用量：<span class="danger">{{ row.dosagePerTime }}</span>
      {{ row.dosageUnit || row.minUnit }}
    </span>
    <span v-if="!isGroup" class="right-pad">
      频次：<span class="danger">{{ row.frequency | dictText("DrugFrequency") }}</span>
    </span>
    <!-- <span v-if="!isGroup" class="right-pad">
        周期：<span class="danger">{{ row.cycles }}{{ currUnit }}</span>
      </span> -->
    <DrugInfo v-for="item in row.items" :key="item.id" :row="item" />
    <el-tag type="info" hit v-if="isGroup && isMaster" style="border-left: #409eff 90px solid" class="top-pad">
      <span style="margin: 0 10px 0 -90px; color: white">{{ groupable }}【{{ row.groupNo }}】</span>
      <span v-if="isMaster" class="left-pad">
        <b>频次：</b><b :class="isMaster ? 'danger' : 'info'">{{ row.frequency | dictText("DrugFrequency") }}</b>
      </span>
      <!-- <span v-if="isMaster" class="left-pad">
        <b>周期：</b><b :class="isMaster ? 'danger' : 'info'">{{ row.days }}</b>
      </span> -->
      <span v-if="isMaster" class="left-pad">
        <b>滴速：</b><b :class="isMaster ? 'danger' : 'info'">{{ row.drops }} 滴/分</b>
      </span>
    </el-tag>
  </el-row>
</template>
<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      row: Object,
    },
    components: {
      DrugInfo: () => import("./_infoDrug.vue"),
    },
    data() {
      return {
        option: {
          loading: false,
          selectedItem: null,
          items: [],
          condition: {
            keyword: null,
            pageSize: 50,
            pageIndex: 0,
          },
        },
      };
    },
    computed: {
      ...mapGetters(["user", "dict"]),
      usage() {
        // 用法
        if (!this.row.usage) {
          return {};
        }
        let usage = this.dict.DrugUsage.find((u) => u.code == this.row.usage);
        if (!usage) {
          return {};
        }
        if (usage.extra) {
          try {
            usage.extraObj = JSON.parse(usage.extra);
          } catch (error) {
            console.log(error);
          }
        }
        return usage;
      },
      groupable() {
        // 是不是可分组，如果是直接返回分组类型
        return this.usage?.extraObj?.groupable;
      },
      isDrip() {
        // 是不是输液
        return this.usage?.extraObj?.isDrip;
      },
      isMaster() {
        if (!this.row.groupNo) {
          return true;
        }
        return this.row.groupNo == this.row.id;
      },
      isGroup() {
        return !!this.row.groupNo;
      },
      currFrequency() {
        if (this.row?.frequency) {
          return this.dict.DrugFrequency.find((f) => f.code == this.row.frequency) || {};
        }
        return {};
      },
      currUnit() {
        if (this.currFrequency.extra) {
          return JSON.parse(this.currFrequency.extra).unit || "次";
        }
        return "次";
      },
    },
  };
</script>
